import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Services
import { GuaranteeTypeEditService } from '../../service/guarantee-type-edit/guarantee-type-edit.service';

@Component({
	selector: 'app-guarantee-type-edit',
	templateUrl: './guarantee-type-edit.component.html',
	providers: [
		GuaranteeTypeEditService,
		HttpModule
	]
})
export class GuaranteeTypeEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	guaranteeType: FormGroup;
	ID: string;
	Nome: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;

	constructor(fb: FormBuilder, private guaranteeTypeEditService: GuaranteeTypeEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.guaranteeType = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.guaranteeTypeEditService.loadGuaranteeType(this.token, this.ID).subscribe(result => {
				var updateCompanyTtype = result.Result;
				this.guaranteeType.setValue({
					ID: updateCompanyTtype.ID,
					Nome: updateCompanyTtype.Nome,
					Ativo: updateCompanyTtype.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editGuaranteeType(value: any) {
		console.log(value);
		this.guaranteeTypeEditService.editGuaranteeType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/tipo-garantia');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-garantia');
	}

}



// WEBPACK FOOTER //
// ./src/app/guarantee-type/component/guarantee-type-edit/guarantee-type-edit.component.ts